import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title?: string;
  description?: string;
  path?: string;
  image?: string;
}

export default function SEO({ title, description, path = '', image }: SEOProps) {
  const siteName = 'AutoCarPost';
  const baseUrl = 'https://autocarpost.com';
  const fullTitle = title ? `${title} | ${siteName}` : `${siteName} — Post Your Car for Sale in Minutes`;
  const desc = description || 'Post your car for sale in minutes. AI writes your listing, syncs to Facebook Marketplace and Craigslist. Free for individual sellers.';
  const url = `${baseUrl}${path}`;
  const img = image || `${baseUrl}/car-hero.jpg`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />
    </Helmet>
  );
}
